import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "icons"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#icons" }),
  /*#__PURE__*/_createTextVNode(" Icons ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "<?php echo Theme::getPageUrl('documentation/icons/duotone')?>",
    class: "fw-bold"
  }, "Duotone Svg Icons"),
  /*#__PURE__*/_createTextVNode(" in conbination with buttons as shown below: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Caption ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = { class: "pt-5 pb-20" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "<?php echo Theme::getPageUrl('documentation/icons/font-awesome')?>",
    class: "fw-bold"
  }, "Font Awesome Icons"),
  /*#__PURE__*/_createTextVNode(" in conbination with buttons as shown below: ")
], -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = { class: "rounded border p-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope-open-text fs-4 me-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Caption ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope-open-text fs-4" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "pt-5 pb-20" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<a href="#" class="btn btn-primary"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-success"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-info"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-warning"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-danger"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-dark"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i> Caption</a
        >

        <a href="#" class="btn btn-icon btn-primary"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-success"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-info"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-warning"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-danger"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-dark"
          ><i class="fas fa-envelope-open-text fs-4 me-2"></i></a
        >`))
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "<?php echo Theme::getPageUrl('documentation/icons/line-awesome')?>",
    class: "fw-bold"
  }, "Line Awesome Icons"),
  /*#__PURE__*/_createTextVNode(" in conbination with buttons as shown below: ")
], -1)
const _hoisted_23 = { class: "py-5" }
const _hoisted_24 = { class: "rounded border p-10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "las la-wallet fs-2" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Caption ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "las la-wallet fs-2" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "py-5" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<a href="#" class="btn btn-icon btn-primary"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-success"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-info"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-warning"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-danger"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >
        <a href="#" class="btn btn-icon btn-dark"
          ><i class="las la-wallet fs-2 me-2"></i> Caption</a
        >

        <a href="#" class="btn btn-icon btn-primary"
          ><i class="las la-wallet fs-2 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-success"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-info"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-warning"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-danger"
          ><i class="las la-wallet fs-3 me-2"></i
        ></a>
        <a href="#" class="btn btn-icon btn-dark"
          ><i class="las la-wallet fs-3 me-2"></i></a
        >`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: "#",
            class: _normalizeClass([`btn-${item}`, "btn me-2 mb-2"])
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-bar3.svg" })
            ]),
            _hoisted_7
          ], 2))
        }), 128)),
        _hoisted_8,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: "#",
            class: _normalizeClass([`btn-${item}`, "btn btn-icon me-2 mb-2"])
          }, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-bar3.svg" })
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<a href="#" class="btn btn-primary"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-success"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-info"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-warning"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-danger"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >
        <a href="#" class="btn btn-dark"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span>Caption</a
        >

        <a href="#" class="btn btn-icon btn-primary"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-success"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-info"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-warning"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-danger"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >
        <a href="#" class="btn btn-icon btn-dark"
          ><span class="svg-icon svg-icon-2"><svg>...</svg></span></a
        >`), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: "#",
            class: _normalizeClass([`btn-${item}`, "btn me-2 mb-2"])
          }, _hoisted_16, 2))
        }), 128)),
        _hoisted_17,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: "#",
            class: _normalizeClass([`btn-${item}`, "btn btn-icon me-2 mb-2"])
          }, _hoisted_19, 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      })
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: "#",
            class: _normalizeClass([`btn-${item}`, "btn me-2 mb-2"])
          }, _hoisted_27, 2))
        }), 128)),
        _hoisted_28,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: "#",
            class: _normalizeClass([`btn-${item}`, "btn btn-icon me-2 mb-2"])
          }, _hoisted_30, 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_32
        ]),
        _: 1
      })
    ])
  ]))
}